<template>
  <section class="hero-section relative h-[500px] flex items-end" :style="(image)?{ backgroundImage: `url(${require(`@/${image}`)})`, backgroundSize: 'cover', backgroundPosition: 'center' }:''">
    <video v-if="video" class="absolute inset-0 w-full h-full object-cover" autoplay muted loop playsinline>
      <source :src="require(`@/${video}`)" type="video/mp4">
    </video>
    <div class="absolute inset-0 bg-black" :class="`opacity-${opacity}`"></div>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full flex justify-between items-end pb-5">
      <h1
        class="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2 animate-slideInUp md:w-[500px] w-[300px] uppercase"
        v-if="title"
      >
        {{ title }}
      </h1>
      <p
        class="text-xl text-white text-center animate-slideInUp md:w-[500px] w-[300px]"
        style="animation-delay: 0.2s"
        v-if="desc"
        v-html="desc"
      ></p>
    </div>
  </section>
</template>

<script setup>
/* global defineProps */
/* eslint-disable no-undef */
defineProps({
  title: {
    type: String,
    required: false
  },
  desc: {
    type: String,
    required: false
  },
  image: {
    type: String,
    required: false
  },
  video: {
    type: String,
    required: false
  },
  opacity:{
    type: String,
    required: false,
    default: '20'
  }
})
</script>